import { get, IHttpRequestConfig, put } from "@/browser";
import { extractDataFromResponse } from "@/core/api";
import { compose } from "@/core/url";

import { IInvitation, invitationType, IRegisterInvitationDto } from "./types";

const API = {
  get: "/api/public/invitations/{invitationId}",
  register: "/api/public/invitations/{invitationId}/register",
  acceptAll: "/api/invitations/accept",
};

export interface IFetchJobRequestApplicationListParams {}

export const acceptAllInvitations = (params?: IFetchJobRequestApplicationListParams, options?: IHttpRequestConfig) => {
  const url = compose(API.acceptAll, params);
  return put<IInvitation>(url, options).then(extractDataFromResponse);
};

export interface IFetchInvitationParams {
  invitationId: number;
  token: string;
}

export const fetchInvitation = (params: IFetchInvitationParams, options?: IHttpRequestConfig) => {
  const { invitationId, ...search } = params;
  const url = compose(API.get, { invitationId }, search);
  return get<IInvitation>(url, options).then(extractDataFromResponse).then(invitationType);
};

export interface IRegisterInvitationParams {
  invitationId: number;
}

export const registerInvitation = (
  params: IRegisterInvitationParams,
  data: IRegisterInvitationDto,
  options?: IHttpRequestConfig,
) => {
  const url = compose(API.register, params);
  return put<boolean>(url, data, options).then(extractDataFromResponse);
};
